import React from 'react';
import { MapPin, Wrench, FileText, Shield, CheckCircle, Award } from 'lucide-react';
export function WhyChoose() {
  const cards = [{
    icon: MapPin,
    title: 'Local Southeast Michigan Auto Glass Team',
    copy: 'Serving drivers from Howell, Ann Arbor, Novi and nearby communities with urgent auto glass help.'
  }, {
    icon: Wrench,
    title: 'Certified Auto Glass Technicians',
    copy: 'Professional repair and replacement for windshields, side glass, rear glass, door glass and vehicle glass.'
  }, {
    icon: FileText,
    title: 'Free Auto Glass Estimates',
    copy: 'Get clear next steps and an estimate before moving forward.'
  }, {
    icon: Shield,
    title: 'Works With Most Insurance',
    copy: 'The team can help with insurance information, claim coordination and scheduling.'
  }, {
    icon: CheckCircle,
    title: 'Quality Glass Options',
    copy: "Kosin's uses high-quality glass that meets or exceeds OEM standards."
  }, {
    icon: Award,
    title: 'Lifetime Workmanship Warranty',
    copy: "Vehicle glass workmanship is backed by Kosin's lifetime warranty."
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1179">
      <div className="max-w-7xl mx-auto" data-id="element-1180">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1181">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-1182">
            Why Drivers Call{' '}
            <span className="text-emergencyBrand-red" data-id="element-1183">Kosin's Glass</span> for
            Urgent Auto Glass
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-1184">
          {cards.map((card, i) => <div key={i} className="bg-white rounded-xl p-6 border border-slate-200 hover:border-emergencyBrand-red/40 hover:shadow-md transition-all" data-id="element-1185">
              <div className="flex items-center gap-4 mb-4" data-id="element-1186">
                <div className="w-11 h-11 bg-emergencyBrand-redLight rounded-lg flex items-center justify-center shrink-0" data-id="element-1187">
                  <card.icon className="w-5 h-5 text-emergencyBrand-red" data-id="element-1188" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 leading-tight" data-id="element-1189">
                  {card.title}
                </h3>
              </div>
              <p className="text-slate-600" data-id="element-1190">{card.copy}</p>
            </div>)}
        </div>
      </div>
    </section>;
}